import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCollections } from './api/collections';

// Page title, description and "hide from search engines" for the browser tab and for Google.
export const DEFAULT_TITLE = 'SANASA Campus - Degrees and Diplomas in Kegalle';

export const applySeo = ({ title, description, noindex } = {}) => {
  document.title = title || DEFAULT_TITLE;

  const desc = document.head.querySelector('meta[name="description"]');
  if (desc) {
    if (!desc.dataset.default) desc.dataset.default = desc.content;
    desc.content = description || desc.dataset.default;
  }

  let robots = document.head.querySelector('meta[name="robots"][data-sc]');
  if (noindex) {
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      robots.dataset.sc = '1';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex, nofollow';
  } else if (robots) {
    robots.remove();
  }
};

// For pages that show one item (a program, an event, a story): pass { title, description } once the item is loaded.
export const useSeo = (seo) => {
  const title = seo && seo.title;
  const description = seo && seo.description;
  const noindex = seo && seo.noindex;
  useEffect(() => {
    if (title) applySeo({ title, description, noindex });
  }, [title, description, noindex]);
};

// Pages with a fixed address (Home, About, Programs...) take their text from the back office (Settings > Search engine text).
const ITEM_PAGE = /^\/(programs|events|news|projects|gallery)\/[^/]+$/;

export const RouteSeo = () => {
  const { pathname } = useLocation();
  const { seoPages } = useCollections('seoPages');

  useEffect(() => {
    if (pathname.startsWith('/admin') || ITEM_PAGE.test(pathname)) return;
    const key = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
    const row = seoPages && seoPages[key];
    applySeo(row ? { title: row.title, description: row.description, noindex: row.noindex } : {});
  }, [pathname, seoPages]);

  return null;
};
